import { WorkflowsListLayout } from "#src/batteries-included-components/Layouts/Workflows/List";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { WorkflowsAllRoutePath } from "#src/routes/workflows/all";
import { useBreadcrumbsFromRoute } from "#src/utils/route";
import { Page } from "@validereinc/common-components";
import { Assets } from "@validereinc/domain-controllers";
import React from "react";

const { AssetTypeSelection } = Assets.view;

export const AllWorkflowsPage = () => {
  const [
    filterConfigStorageKey,
    tableConfigStorageKey,
    viewConfigStorageKey,
    tableStateStorageKey,
    groupByTablesStateStorageKey,
  ] = useStorageKey(
    [
      "filter-configuration",
      "table-configuration",
      "view-configuration",
      "table-state",
      "group-by-tables-state",
    ],
    ["workflows", "list"]
  );
  const [breadcrumbs] = useBreadcrumbsFromRoute(WorkflowsAllRoutePath);

  return (
    <Page
      title={WorkflowsAllRoutePath.title}
      category={WorkflowsAllRoutePath.subtitle}
      breadcrumbs={breadcrumbs}
    >
      <WorkflowsListLayout
        tablePanelProps={{
          filterConfigStorageKey,
          tableConfigStorageKey,
          viewConfigStorageKey,
          tableStateStorageKey,
          groupByTablesStateStorageKey,
        }}
        defaultAssetType={AssetTypeSelection.ALL_ASSETS}
      />
    </Page>
  );
};
